<template>
  <div class="local-tenant display-flex width-percent-100 height-percent-100">
    <div class="left bc-white br-4 padding-20">
      <div class="mb-20">
        <b class="fs-18">本地化租户</b>
      </div>
    </div>
    <div class="right bc-white br-4 display-flex ai-center jc-center">
      <el-empty description="功能开发中"></el-empty>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LocalTenant', // 本地化租户
  components: {},
  props: {},
  data () {
    return {}
  },
  filters: {},
  computed: {},
  watch: {},
  methods: {},
  beforeCreate () {
  },
  created () {
  },
  beforeMount () {
  },
  mounted () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
.local-tenant {
  overflow: hidden;
  .left {
    width: 340px;
    flex-shrink: 0;
    margin-right: 16px;
    box-sizing: border-box;
  }
  .right {
    flex: 1;
    min-width: 0;
  }
}
</style>
